const FALLBACK_LANG = process.env.FALLBACK_LANG

export default function getSystemLanguage() {
  let lang = FALLBACK_LANG

  // Matching language
  const queryLanguage = (window.location.search.match(/lang=([^&]+)/i) || [])[1]

  // Prefer ?lang= than settings than navigator.language
  lang = queryLanguage || lang
  // eslint-disable-next-line
  // console.log('System Language: ', lang)
  if (['zh-tw', 'zh-sg', 'zh-hk'].indexOf(lang) > -1) {
    lang = 'zh-cn'
  }
  return lang
}
